import React, { useState } from "react";
import InitialsTable from "../tables/InitialsTable";
import { useEffect } from "react";
import { UseSorting } from "../common/UseSorting";

function InitialsTab({
  searchTerm = "",
  currentPage = 1,
  itemsPerPage = 5,
  handleEditClick,
  data,
  handleDeleteClick,
  selectedRows,
  setSelectedRows,
}) {
  const { sortConfig, handleSort, renderSortIcon, sortData, resetSort } =
    UseSorting();
  const sortableFields = ["NAME", "INITIALS"];

  // Reset sort when tab data changes
  useEffect(() => {
    resetSort();
  }, [data]);
  // Apply sorting
  const sortedData = sortData(Array.isArray(data) ? data : [], sortableFields);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  // All IDs from all pages for this tab
  const allIds = sortedData.map((r) => r.record_id);

  const isAllSelected = allIds.length > 0 && allIds.every((id) => selectedRows.includes(id));

  const isSomeSelected =
    selectedRows.length > 0 && !isAllSelected && selectedRows.some((id) => allIds.includes(id));

  const handleSelectRow = (recordId) => {
    setSelectedRows((prev) => (prev.includes(recordId) ? prev.filter((id) => id !== recordId) : [...prev, recordId]));
  };

  // Select/Deselect ALL rows from ALL pages
  const handleSelectAll = (isChecked) => {
    if (!Array.isArray(sortedData) || sortedData.length === 0) return;
    const allIds = sortedData.map((r) => r.record_id);
    setSelectedRows((prev) => (isChecked ? Array.from(new Set([...prev, ...allIds])) : prev.filter((id) => !allIds.includes(id))));
  };

  return (
    <InitialsTable
      data={currentItems}
      startIndex={indexOfFirstItem}
      handleEditClick={handleEditClick}
      handleDeleteClick={handleDeleteClick}
      selectedRows={selectedRows}
      handleSelectRow={handleSelectRow}
      handleSelectAll={handleSelectAll}
      sortableFields={sortableFields}
      handleSort={handleSort}
      renderSortIcon={renderSortIcon}
      isAllSelected={isAllSelected}
      isSomeSelected={isSomeSelected}
    />
  );
}

export default InitialsTab;
